import React from 'react';
import i18n from 'i18next';
import { css } from '@emotion/core';
import Typography from '@material-ui/core/Typography';
import { below } from 'utils/breakpoint';
import FormInfoButton from 'client/components/Result/EntriesInfo/form/FormInfoButton';

export default function SerialDateInfo({
    id,
    date,
    children,
    showFormBtn = false,
    formIds,
    entryUuid
}) {
    return (
        <>
            <div css={listStyle}>
                <Typography variant="subtitle1">
                    <span css={dateStyle}>{date}</span>
                </Typography>
                <div css={rightStyle}>
                    <Typography variant="subtitle1" css={numStyle}>
                        {i18n.t('label.serial_number')}
                        {id}
                    </Typography>
                    {showFormBtn && <FormInfoButton formIds={formIds} entryUuid={entryUuid} />}
                </div>
            </div>

            {children}
        </>
    );
}

const listStyle = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    > * {
        color: inherit;
    }
`;

const numStyle = css`
    padding-right: 8px;
    ${below('sm')} {
        padding-right: 4px;
    }
`;

const dateStyle = css`
    @media only screen and (max-width: 380px) {
        display: inline-block;
    }
`;

const rightStyle = css`
    display: flex;
    align-items: center;
`;
